import React from "react";
import { router, Stack, useLocalSearchParams } from "expo-router";

import { HeaderX } from "~/components/HeaderElements";
import { MoveSaveForm } from "~/components/MoveSave/Form";
import { decodeSaveIDsFromURL } from "~/app/(app)/(authenticated)/[account]/(space)/[space]/saves";

function MoveToIndexPage() {
  const params = useLocalSearchParams<{
    sourceSpaceId: string;
    ids: string;
  }>();

  const saveIDs = decodeSaveIDsFromURL(params.ids!);

  return (
    <>
      <Stack.Screen
        options={{
          headerTitle: `Move ${saveIDs.length} saves`,
          headerRight: () => <HeaderX onPress={router.back} />,
        }}
      />
      <MoveSaveForm
        onSuccess={() => {
          router.back();
        }}
        saveIds={saveIDs}
        srcSpaceId={params.sourceSpaceId!}
      />
    </>
  );
}

export default MoveToIndexPage;
